export default __webpack_public_path__ + "static/media/BMFlogo2-01.44a8ddd3.png";